// extracted by mini-css-extract-plugin
export default {"pageHeading":"ResponsivePage_pageHeading__tWEo9","backIcon":"ResponsivePage_backIcon__owaJI","responsiveForm":"ResponsivePage_responsiveForm__2xz55"};